import { Variants } from "motion/react";

export const detailPanelContainerAnimations: Variants = {
  initial: {
    opacity: 0,
    filter: "blur(10px)",
    transition: {
      duration: 0.5,
      ease: "easeIn",
    },
  },
  animate: {
    opacity: 1,
    filter: "blur(0px)",
    transition: {
      duration: 0.6,
      ease: "easeOut",
    },
  },
  exit: {
    opacity: 1,
    filter: "blur(10px)",
    transition: {
      duration: 0.4,
      ease: "easeInOut",
    },
  },
};
